import { createAction } from 'typesafe-actions'

export const setLanguageIsLoaded = createAction('DOC / i18n / set language is loaded')<boolean>()
